<template>
  <PreviewFrame :accent="slide.accent">
    <template #presenter>
      <span class="tb-title"></span>
      <div class="tb-grid" role="presentation">
        <div class="tb-row tb-row--head">
          <span v-for="i in 4" :key="'h' + i" class="tb-cell tb-cell--head">
            <span class="tb-bar"></span>
          </span>
        </div>
        <div v-for="r in 3" :key="'r' + r" class="tb-row">
          <span v-for="c in 4" :key="'c' + r + '-' + c" class="tb-cell">
            <span class="tb-bar tb-bar--cell" :style="{ width: cellWidth(r, c) + '%' }"></span>
          </span>
        </div>
      </div>
    </template>
  </PreviewFrame>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue'
import type { SlideType } from '../../data/slideTypeCatalog'
import PreviewFrame from './PreviewFrame.vue'

export default Vue.extend({
  name: 'PreviewTable',
  components: { PreviewFrame },
  props: { slide: { type: Object as PropType<SlideType>, required: true } },
  methods: {
    cellWidth(r: number, c: number): number {
      const seed = [60, 75, 50, 80, 65, 55, 70, 45, 72, 58, 82, 50]
      return seed[((r - 1) * 4 + (c - 1)) % seed.length]
    },
  },
})
</script>

<style scoped lang="scss">
.tb-title {
  display: block;
  height: 12px;
  width: 40%;
  border-radius: 999px;
  background: rgba(15, 15, 20, 0.22);
}
.tb-grid {
  flex: 1;
  display: flex;
  flex-direction: column;
  border: 1px solid rgba(15, 15, 20, 0.1);
  border-radius: 6px;
  overflow: hidden;
  min-height: 120px;
}
.tb-row {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
}
.tb-row + .tb-row .tb-cell {
  border-top: 1px solid rgba(15, 15, 20, 0.08);
}
.tb-cell {
  padding: 9px 10px;
  display: flex;
  align-items: center;
}
.tb-cell + .tb-cell {
  border-left: 1px solid rgba(15, 15, 20, 0.08);
}
.tb-row--head { background: color-mix(in srgb, var(--accent) 16%, white); }
.tb-cell--head { padding: 8px 10px; }
.tb-bar {
  display: block;
  height: 6px;
  border-radius: 999px;
  background: var(--accent);
  width: 60%;
}
.tb-bar--cell { background: rgba(15, 15, 20, 0.14); }
</style>
